import { render, staticRenderFns } from "./Pupils.vue?vue&type=template&id=6b2220a8&"
import script from "./Pupils.vue?vue&type=script&lang=js&"
export * from "./Pupils.vue?vue&type=script&lang=js&"
import style0 from "./Pupils.vue?vue&type=style&index=0&id=6b2220a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports